const columnConfig = [
  {
    title: 'id',
    accessor: 'id',
    name: 'id',
    filterable: false,
    sortable: false,
    width: 50,
  },
  {
    title: 'name',
    name: 'name',
    accessor: 'name',
    filterable: true,
    sortable: true,
  },
  {
    title: 'priority',
    name: 'position',
    accessor: 'position',
    filterable: false,
    sortable: true,
  },
];

export default columnConfig;
